export const UPDATE_CURRENT_USER = 'UPDATE_CURRENT_USER';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_CURRENT_USER_SETTINGS = 'SET_CURRENT_USER_SETTINGS';
export const REMOVE_CURRENT_USER = 'REMOVE_CURRENT_USER';
export const SET_USER_LOADING_STATE = 'SET_USER_LOADING_STATE';
